import { Shield, Award, CheckCircle, MapPin, Building2, FileText } from "lucide-react";
import SectionFadeIn from "@/components/SectionFadeIn";
import { useTranslation } from 'react-i18next';

const TrustBar = () => {
  const { t } = useTranslation('home');

  const badges = [
    { icon: Award, label: t('trustBar.dobLicensed') },
    { icon: Shield, label: t('trustBar.qewiInspectors') },
    { icon: CheckCircle, label: t('trustBar.insured') },
    { icon: MapPin, label: t('trustBar.boroughs') },
  ];

  const certs = [
    { icon: Award, label: t('certifications.items.licensedPE') },
    { icon: Building2, label: t('certifications.items.aiaMember') },
    { icon: FileText, label: t('certifications.items.oshaCompliant') },
  ];

  return (
    <section className="bg-foreground py-8 border-b border-white/10">
      <div className="container-max px-4 sm:px-6 lg:px-8">
        <SectionFadeIn>
          {/* Primary trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {badges.map((badge) => (
              <div key={badge.label} className="flex items-center gap-3">
                <badge.icon className="h-5 w-5 text-brand-yellow flex-shrink-0" />
                <span className="text-primary-foreground text-xs sm:text-sm font-medium whitespace-nowrap">{badge.label}</span>
              </div>
            ))}
          </div>

          {/* Certifications row */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-5 pt-5 border-t border-white/10">
            {certs.map((cert) => (
              <div key={cert.label} className="flex items-center gap-2">
                <cert.icon className="h-4 w-4 text-white/40 flex-shrink-0" />
                <span className="text-white/50 text-xs font-medium uppercase tracking-wider whitespace-nowrap">{cert.label}</span>
              </div>
            ))}
            {/* Sika badge */}
            <div className="flex items-center gap-2">
              <span className="text-white/50 text-xs font-bold uppercase tracking-wider">{t('certifications.sika.brand')}</span>
              <span className="text-brand-yellow/60 text-xs font-medium uppercase tracking-wider">{t('certifications.sika.badge')}</span>
            </div>
          </div>
        </SectionFadeIn>
      </div>
    </section>
  );
};

export default TrustBar;
